import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import {
	Button,
	ModalContainer,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalTitle,
	Overlay,
} from './Modal.styles';
import { ApButtonIcon } from '@alixpartners/ui-components';

const MODAL_ID = 'category_widget_modal';

const addPortal = () => {
	let portal = document.getElementById(MODAL_ID);
	if (!portal) {
		portal = document.createElement('div');
		portal.id = MODAL_ID;
		document.body.appendChild(portal);
	}
	return portal;
};

const Modal = ({
	title,
	isFullScreen,
	width,
	height,
	zIndex,
	closeLabel,
	onClose,
	children,
}) => {
	const [isVisible, setIsVisible] = useState(true);

	useEffect(
		() => {
			const handleKeyDown = e => {
				if (e.key === 'Escape') {
					onClose();
				}
			};

			document.addEventListener('keydown', handleKeyDown);

			return () => {
				document.removeEventListener('keydown', handleKeyDown);
			};
		},
		[onClose]
	);

	const closeWithAnimation = () => {
		setIsVisible(false);
		setTimeout(onClose, 100);
	};

	const handleOverlayClick = e => {
		if (e.target === e.currentTarget) {
			closeWithAnimation();
		}
	};

	const portalElement = addPortal();

	return ReactDOM.createPortal(
		<Overlay zIndex={zIndex} onClick={handleOverlayClick} isVisible={isVisible}>
			<ModalContainer isFullScreen={isFullScreen} width={width} height={height}>
				<ModalHeader>
					<ModalTitle>{title}</ModalTitle>
					<div>
						<ApButtonIcon
							title={closeLabel || 'Close'}
							iconName="close"
							onClick={closeWithAnimation}
						/>
					</div>
				</ModalHeader>
				<ModalContent>{children}</ModalContent>
				<ModalFooter>
					<Button type="button" onClick={closeWithAnimation}>
						{closeLabel}
					</Button>
				</ModalFooter>
			</ModalContainer>
		</Overlay>,
		portalElement
	);
};

export default Modal;
